import React, { Component } from "react";
import { QueryRenderer } from "@cubejs-client/react";

import cubejs from "../cube";

import {
  HorizontalBarChart as HorizonBarChart,
  LineChart,
} from "../components/visualizations";
import { generateBarData, generateLineData } from "../utils/visualizations";
import { MainWrapper } from "../components/newDesign/MainWrapper";
import { TabMainTitle } from "../components/newDesign/TabMainTitle";
import { FilterWrapper } from "../components/newDesign/FilterWrapper";
import { FilterItem } from "../components/newDesign/FilterItem";
import { SelectList } from "../components/newDesign/SelectList";
import { RowWrapper } from "../components/newDesign/RowWrapper";
import { ChartCard } from "../components/newDesign/ChartCard";
import {
  CHART_MAIN_COLOR,
  CHART_SECONDARY_COLOR,
} from "../components/newDesign/utils";

const cubejsApi = cubejs({ appId: 1 });

export default class ParticipantCategory extends Component {
  state = {
    filtersData: {
      "ParticipantCategory.category": {
        key: "ParticipantCategory.category",
        title: "Категория",
        options: [],
        values: [],
        size: 6,
      },
      "ParticipantCategory.year": {
        key: "ParticipantCategory.year",
        title: "Год",
        options: [],
        values: [],
        size: 4,
      },
    },
  };

  async componentDidMount() {
    let { filtersData } = this.state;
    const filterNames = Object.keys(filtersData);
    const reqs = filterNames.map((f) => cubejsApi.load({ dimensions: [f] }));
    const responses = await Promise.all(reqs);

    responses.forEach((res, i) => {
      filtersData = {
        ...filtersData,
        [filterNames[i]]: {
          ...filtersData[filterNames[i]],
          options: res.rawData().map((d) => d[filterNames[i]]),
        },
      };
    });
    this.setState({ filtersData });
  }

  applyFilters = (filter, values) => {
    let { filtersData } = this.state;
    this.setState({
      filtersData: {
        ...filtersData,
        [filter]: {
          ...filtersData[filter],
          values,
        },
      },
    });
  };

  render() {
    const { filtersData } = this.state;
    const filterNames = Object.keys(filtersData);

    let filters = [];
    filterNames.forEach((f) => {
      const filter = filtersData[f];
      if (filter.values.length) {
        filters = [
          ...filters,
          {
            member: f,
            operator: "equals",
            values: filter.values.map((f) => f.toString()),
          },
        ];
      }
    });

    return (
      <MainWrapper>
        <TabMainTitle>
          Категория участников внешнеэкономической деятельности
        </TabMainTitle>
        <FilterWrapper>
          {filterNames.map((f, i) => {
            const filter = filtersData[f];
            return (
              <FilterItem>
                <SelectList
                  label={filter.title + ":"}
                  mode="multiple"
                  onChange={(value) => this.applyFilters(filter.key, value)}
                  size="small"
                  allowClear
                  list={filter.options}
                />
              </FilterItem>
            );
          })}
        </FilterWrapper>

        <RowWrapper>
          <ChartCard
            title="Среднее значение экспорта и импорта по категории участников
            внешнеэкономической деятельности (тыс. долл. США)"
          >
            <QueryRenderer
              query={{
                measures: [
                  "ParticipantCategory.importAverage",
                  "ParticipantCategory.exportAverage",
                ],
                dimensions: ["ParticipantCategory.category"],
                filters,
                order: {
                  "ParticipantCategory.exportAverage": "asc",
                },
              }}
              cubejsApi={cubejsApi}
              render={({ resultSet }) => {
                return (
                  <HorizonBarChart
                    loading={!resultSet}
                    id="HorizonBarChart"
                    {...generateBarData(resultSet)}
                    wrapLabels
                    height="1250px"
                    colorsArr={[CHART_MAIN_COLOR, CHART_SECONDARY_COLOR]}
                  />
                );
              }}
            />
          </ChartCard>
          <div style={{ flex: 1 }}>
            <div>
              <ChartCard
                title="Импорт по категориям участников внешнеэкономической деятельности
            (тыс. долл. США)"
              >
                <QueryRenderer
                  query={{
                    measures: ["ParticipantCategory.importSum"],
                    dimensions: [
                      "ParticipantCategory.category",
                      "ParticipantCategory.year",
                    ],
                    filters,
                    order: {
                      "ParticipantCategory.year": "asc",
                    },
                  }}
                  cubejsApi={cubejsApi}
                  render={({ resultSet }) => {
                    return (
                      <LineChart
                        loading={!resultSet}
                        id="LineChartImport"
                        {...generateLineData(resultSet)}
                        filled
                        rotate
                        height="600px"
                      />
                    );
                  }}
                />
              </ChartCard>
            </div>
            <div>
              <ChartCard
                title="Экспорт по категориям участников внешнеэкономической
            деятельности (тыс. долл. США)"
              >
                <QueryRenderer
                  query={{
                    measures: ["ParticipantCategory.exportSum"],
                    dimensions: [
                      "ParticipantCategory.category",
                      "ParticipantCategory.year",
                    ],
                    filters,
                    order: {
                      "ParticipantCategory.year": "asc",
                    },
                  }}
                  cubejsApi={cubejsApi}
                  render={({ resultSet }) => {
                    return (
                      <LineChart
                        loading={!resultSet}
                        id="LineChartExport"
                        {...generateLineData(resultSet)}
                        filled
                        rotate
                        height="600px"
                      />
                    );
                  }}
                />
              </ChartCard>
            </div>
          </div>
        </RowWrapper>
      </MainWrapper>
    );
  }
}
